// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"05012252","453":"e80f55de"}[chunkId] + ".chunk.js";
};